import React, { PureComponent } from 'react';
import { Flex } from '../../common/Flex';
import { MainFlowGraph } from './svg/MainFlowGraph';

export class MainFlowsV2 extends PureComponent {
    render() {
        const canariaValues = [
            0.2, 0.25, 0.3, 0.3, 0.3, 0.4, 0.45, 0.3, 0.3, 0.55, 0.6, 0.7, 0.75, 0.78, 0.8, 0.85, 0.75, 0.7, 0.6, 0.45,
            0.35, 0.2, 0.2, 0.25,
        ];
        const southEastValues = [
            0.1, 0.05, 0.15, 0.17, 0.19, 0.22, 0.24, 0.26, 0.24, 0.2, 0.21, 0.23, 0.26, 0.3, 0.35, 0.38, 0.42, 0.35,
            0.3, 0.24, 0.19, 0.17, 0.14, 0.09,
        ];
        return (
            <Flex direction="vertical" className="disabled" style={{ padding: '0.5em' }}>
                <div style={{ margin: '1em 0em' }}>
                    <div>
                        <div style={{ fontWeight: 'bold' }}>FLOW UK - CANARIA</div>
                    </div>
                    <div style={{ margin: '1em 0' }}>
                        <MainFlowGraph heightEm={8} values={canariaValues} />
                    </div>
                </div>
                <div style={{ margin: '1em 0em' }}>
                    <div>
                        <div style={{ fontWeight: 'bold' }}>FLOW SOUTH EAST AXIS</div>
                    </div>
                    <div style={{ margin: '1em 0' }}>
                        <MainFlowGraph heightEm={8} values={southEastValues} />
                    </div>
                </div>
            </Flex>
        );
    }
}
